<template>
  <div class="relative">
    <div class="form-input--table pr-1">
      <div class="material-bar">
        <h5 class="imp">Select Resource Instances</h5>
      </div>

      <div v-if="!availableResourceOptions.length" class="no-resources-message">
        No resources available for this factory and workflow step.
      </div>
      <custom-multi-select
        v-else
        :options="mappedOptions"
        :selected="selectedResourceIds"
        @input="handleResourceSelection"
        placeholder="Select Resources"
      />
    </div>
  </div>
</template>

<script>
import customMultiSelect from '@/components/common/customMultiSelect.vue'

export default {
  name: 'resourceSelectionComp',
  components: {
    customMultiSelect
  },
  props: {
    open: {
      type: Boolean,
      default: true
    },
    availableResources: {
      type: Array,
      default: () => []
    },
    selectedResources: {
      type: Array,
      default: () => []
    }
  },
  data () {
    return {
      selectedIds: []
    }
  },
  computed: {
    availableResourceOptions () {
      return this.availableResources || []
    },
    mappedOptions () {
      return this.availableResourceOptions.map(opt => ({
        id: opt.value,
        name: opt.label,
        disabled: false
      }))
    },
    selectedResourceIds () {
      return this.selectedResources.map(r => r.value || r.id || r) || []
    }
  },
  methods: {
    handleResourceSelection (selectedOptions) {
      this.selectedIds = selectedOptions
    },
    closeModal () {
      this.$emit('close')
    }
  },
  watch: {
    selectedIds (newIds) {
      const selectedResourcesData = this.availableResourceOptions.filter(
        opt => newIds.includes(opt.value)
      )
      this.$emit('select', selectedResourcesData)
    }
  }
}
</script>

<style lang="scss" scoped>
.material-bar {
  margin-bottom: 0.75rem;

  h5 {
    font-size: 0.9rem;
    font-weight: 500;
    margin: 0;
  }
}

.no-resources-message {
  padding: 1rem;
  background-color: #fff3cd;
  border: 1px solid #ffc107;
  border-radius: 4px;
  color: #856404;
  font-size: 0.85rem;
  text-align: center;
}

.footer-box {
  display: flex;
  justify-content: flex-end;
  gap: 1rem;
  padding-top: 1rem;
  border-top: 1px solid #dee2e6;
}
</style>
